import Sidebar from '../components/SideBar';
import InfoResumo from '../components/socioeconomico/InfoResumo';
import DadosCarrossel from '../components/socioeconomico/DadosCarrossel';
import FiltrosSocio from '../components/socioeconomico/FiltrosSocio';
import '../styles/socioeconomicoStyle/Socioeconomico.css';
import MapaSocioeconomico from '../components/socioeconomico/MapaSocioeconomico';
import { useState, useEffect } from 'react';
import { RegiaoItem, socioeconomicoService } from '../API/socioeconomicoService';

type Filtros = {
  estado: string;
  municipio: RegiaoItem | null;
};

export default function Socioeconomico() {
  const [carrosselOpen, setCarrosselOpen] = useState(false); // controla overlay
  const [filtrosAplicados, setFiltrosAplicados] = useState<Filtros | null>(null);
  const [mapData, setMapData] = useState<any>({
    municipios: undefined,
    bairros: undefined,
    setores: undefined,
    centro: undefined,
  });
  const [mapaNivel, setMapaNivel] = useState<'municipios' | 'bairros' | 'setores'>('bairros');

  useEffect(() => {
    const municipioSelecionado = filtrosAplicados?.municipio;
    if (!municipioSelecionado) return;

    const fetchMapa = async () => {
      try {
        switch (mapaNivel) {
          case 'municipios': {
            const res = await socioeconomicoService.getMunicipiosMapa(municipioSelecionado);
            setMapData((prev: any) => ({
              ...prev,
              municipios: res.features,
              centro: res.centroGeral ?? res.centro,
            }));
            break;
          }
          case 'bairros': {
            const res = await socioeconomicoService.getBairro(municipioSelecionado);
            setMapData((prev: any) => ({
              ...prev,
              bairros: res.features,
              centro: res.centroGeral ?? res.centro,
            }));
            break;
          }
          case 'setores': {
            const res = await socioeconomicoService.getSetores(municipioSelecionado);
            setMapData((prev: any) => ({
              ...prev,
              setores: res.features,
              centro: res.centroGeral ?? res.centro,
            }));
            break;
          }
          default:
            break;
        }
      } catch (error) {
        console.error('❌ Erro ao carregar mapa:', error);
      }
    };

    fetchMapa();
  }, [filtrosAplicados, mapaNivel]);

  return (
    <div style={{ display: 'flex', background: '#f5f5f5' }}>
      <Sidebar />
      <div className="socio-container">
        <h2>Dados socioeconômicos</h2>
        <p>Dados demográficos e socioeconômicos do município.</p>

        <FiltrosSocio onFiltrar={setFiltrosAplicados} />
        <InfoResumo filtros={filtrosAplicados} />

        <div className="map-container" style={{ height: '600px', flex: 2, position: 'relative', marginTop: '30px' }}>
          {mapData && (
            <MapaSocioeconomico
              data={mapData}
              nivel={mapaNivel}
              onNivelChange={setMapaNivel}
              initialViewState={
                mapData.centro
                  ? {
                      latitude: mapData.centro.latitude,
                      longitude: mapData.centro.longitude,
                      zoom: 12,
                    }
                  : undefined
              }
            />
          )}

          {/* Botão hamburguer */}
          {filtrosAplicados && (
            <button
              className="hamburger-btn-socio"
              onClick={() => setCarrosselOpen(!carrosselOpen)}
            >
              ☰
            </button>
          )}

          {/* Carrossel lateral */}
          {carrosselOpen && (
            <div className="carrossel-sidebar">
              <DadosCarrossel filtros={filtrosAplicados} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
